import type { Theme } from '@ori-ui/mui';

import { type Price } from '../../types';

export const getCurrentPriceColor = (theme: Theme, oldPriceVisible?: boolean) =>
  oldPriceVisible ? theme.palette.offer.main : theme.palette.text.primary;

export const isOldPriceVisible = ({
  currentFormatted,
  oldFormatted,
}: Pick<Price, 'currentFormatted' | 'oldFormatted'>) => Boolean(oldFormatted) && oldFormatted !== currentFormatted;
